<template>
    <player-embed-controler
        v-slot:default="{ playerEmbed, methods }"
        class="add-episode-player"
    >
        <add-episode-player-wrapper
            :player-embed="playerEmbed"
            :initialize-embed="methods.initializeEmbed"
            :set-global-config="methods.setGlobalConfig"
            :set-embed-setting="methods.setEmbedSetting"
            :show="show"
        />
    </player-embed-controler>
</template>
<script>
import AddEpisodePlayerWrapper from './AddEpisodePlayerWrapper';
import PlayerEmbedControler from '@/components/PlayerEmbedControler';

export default {
    components: {
        AddEpisodePlayerWrapper,
        PlayerEmbedControler,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },
};
</script>
